import { render, staticRenderFns } from "./PageProgress.vue?vue&type=template&id=6d8869a2&scoped=true"
import script from "./PageProgress.vue?vue&type=script&lang=js"
export * from "./PageProgress.vue?vue&type=script&lang=js"
import style0 from "./PageProgress.vue?vue&type=style&index=0&id=6d8869a2&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d8869a2",
  null
  
)

export default component.exports